export default "__VITE_ASSET__B9nxpma6__"